import React, { useRef, useEffect, useState } from 'react'

import { useField } from '@unform/core'
import classNames from 'classnames'

import { Input } from '../../input'
import { Componente, Erro } from './styles'
import { InputUnformProps } from './tipos'

export const CepInputUnform: React.FC<Omit<InputUnformProps, 'mascara'>> = ({
  name,
  semMargemAbaixo,
  className,
  onChange,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const {
    fieldName,
    defaultValue,
    registerField,
    error,
    clearError
  } = useField(name || '')

  const [valor, definirValor] = useState(defaultValue ?? '')

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      getValue({ value }) {
        return value && value.replace(/\D/g, '')
      },
      setValue(ref: any, value: string) {
        definirValor(value)
        ref.setInputValue(value)
      },
      clearValue(ref: any) {
        definirValor('')
        ref.setInputValue('')
      }
    })
  }, [fieldName, registerField])

  return (
    <Componente
      ComErro={!!error}
      className={classNames(className, {
        semMargemAbaixo
      })}
    >
      <Input
        {...rest}
        name={name}
        value={valor}
        ref={inputRef}
        erro={!!error}
        className={classNames({
          error
        })}
        mascara="99999-999"
        type="tel"
        onChange={e => {
          definirValor(e.target.value)
          onChange && onChange(e)
        }}
        onKeyPress={clearError}
      />
      <Erro id={`erro-${rest.id}`}>{error}</Erro>
    </Componente>
  )
}
